import {
    request
} from '../lib/http_request'
import {
    apis
} from '../lib/apis'


// 维护战区
const worldMaintenance = obj => new Promise((resolve, reject) => {
    const {
        worldMaintenanceForm,
        token
    } = obj;
    request({
        url: apis.beasts_machine_world_maintenance + '?token=' + token,
        data: worldMaintenanceForm
    }).then(res => {
        resolve(res);
    })
});

// 服务器注册开关
const registerSwitch = obj => new Promise((resolve, reject) => {
    const {
        switchServerRegisterForm,
        token
    } = obj;
    request({
        url: apis.beasts_machine_server_register_switch + '?token=' + token,
        data: switchServerRegisterForm
    }).then(res => {
        resolve(res);
    })
});

// 游戏服修改
const changeGameMachineInfo = obj => new Promise((resolve, reject) => {
    const {
        beastsMachineChangeBO,
        token
    } = obj;
    request({
        url: apis.beasts_machine_change_game_machine_info + '?token=' + token,
        data: beastsMachineChangeBO
    }).then(res => {
        resolve(res);
    })
});

// 战区修改
const changeWorldMachineInfo = obj => new Promise((resolve, reject) => {
    const {
        beastsMachineChangeBO,
        token
    } = obj;
    request({
        url: apis.beasts_machine_change_world_machine_info + '?token=' + token,
        data: beastsMachineChangeBO
    }).then(res => {
        resolve(res);
    })
});


export default {
    worldMaintenance,
    registerSwitch,
    changeGameMachineInfo,
    changeWorldMachineInfo

}



// WEBPACK FOOTER //
// ./src/service/machine_api.js